<template>
  <div class="absolute z-100">
    <div v-if="show" class="w-full h-full mt-32 flex flex-col justify-center items-center gap-2">
      <img class="w-48" v-if="success" src="../assets/icons/success.png" alt="guardado correctamente">
      <img class="w-48" v-else src="../assets/icons/error.png" alt="error intentando guardar">
      <div v-if="message" class="px-4 py-2 rounded-lg text-sm font-medium text-center max-w-xs shadow"
        :class="success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
        {{ message }}
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: 'Alert',
  props: {
    message: String,
    success: Boolean
  },
  data() {
    return {
      show: true,
    };
  },
  computed: {
  },
  methods: {
    closeAlert() {
      this.show = false;
      this.$emit('close', false);
    },
    startAutoClose() {
      setTimeout(() => {
          this.closeAlert();
      }, 2000);
    }
  },
  mounted() {
    this.startAutoClose();
  },
};
</script>

<style>
  .alertClasses {
    padding: 4px !important;
    background-color: whitesmoke !important;
    position: absolute !important;
    left: 5px !important; /* Adjust the offset as needed */
    top: 5px !important;
    border: solid 1px rgb(226, 12, 12) !important;
    border-radius: 1rem !important;
    z-index: 1000 !important;
  }
</style>